import _defineProperty from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';
import { browser, createElement } from '../utils/dom';
var defaultContainer = browser ? {
  current: document.body
} : {
  current: null
};
var useDOMRoot = function useDOMRoot(_ref) {
  var anchor = _ref.anchor,
    style = _ref.style,
    _ref$container = _ref.container,
    container = _ref$container === void 0 ? defaultContainer : _ref$container;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    root = _useState2[0],
    setRoot = _useState2[1];
  useEffect(function () {
    if (!container.current) {
      return;
    }
    var launchpad = container.current.querySelector(":scope > [data-".concat(anchor, "]"));
    if (!launchpad) {
      launchpad = createElement('div', _defineProperty({
        className: style
      }, "data-".concat(anchor), ''));
      container.current.appendChild(launchpad);
    }
    setRoot(launchpad);
  }, [container, anchor, style]);
  return root;
};
export default useDOMRoot;